import { createFileRoute, redirect } from '@tanstack/react-router'
import { ReceiptDetailScreen } from '@/features/purchasing-receipts/receipt-detail-screen'
import { hasGrant } from '@/lib/me'

/** `.index` keeps this a sibling under `receipts.tsx`'s own Outlet. */
export const Route = createFileRoute('/_authenticated/purchasing/receipts/$receiptId/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'goods_receipt.view')) {
      throw redirect({ to: '/purchasing/receipts' })
    }
  },
  component: GoodsReceiptDetailRoute,
})

function GoodsReceiptDetailRoute() {
  const { receiptId } = Route.useParams()

  return <ReceiptDetailScreen receiptId={receiptId} />
}
